import { IgChip } from "@intelligems/ig-theme";
import {
  IgCoreTextColors,
  IgInteractiveBackgroundColors,
} from "@intelligems/ig-design-tokens";

export const TrialNavBadge = () => (
  <IgChip
    color="default"
    label="New offer"
    size="small"
    sx={{
      backgroundColor: IgInteractiveBackgroundColors.accent.default,
      borderColor: "transparent",
      color: IgCoreTextColors.dark,
      fontWeight: 400,
      height: "20px !important",
    }}
  />
);
